import React, {useEffect, useRef} from "react";
import PropTypes from "prop-types";

const AnchorLinker = ({anchorName, children}) => {
    const anchorRef = useRef(null);
    useEffect(() => {
        const t = setTimeout(() => {
            if (anchorRef && location.hash.includes(`${anchorName}`)) {
                anchorRef.current?.scrollIntoView(true);
            }
        }, 500);

        return () => clearTimeout(t);

    }, [anchorRef]);


    return (
        <div
            ref={anchorRef}
        >
            {children}
        </div>
    );
};

AnchorLinker.propTypes = {
    anchorName: PropTypes.string,
    children: PropTypes.object
};

export default AnchorLinker;